import StatusInfo from './StatusInfo';

export default StatusInfo;
